document.addEventListener("DOMContentLoaded", () => {
  const cleanA11y = () => {
    const summaries = document.querySelectorAll('summary');
    if (summaries.length) {
      summaries.forEach(el => {
        el.removeAttribute('role');
      });
    }

    const searchInputs = document.querySelectorAll('input.search__input');
    if (searchInputs.length) {
      searchInputs.forEach(input => {
        input.removeAttribute('role');
      });
    }

    const headerIcons = document.querySelectorAll('summary.header__icon');
    if (headerIcons.length) {
      headerIcons.forEach(el => {
        el.setAttribute('aria-label', 'Open search');
      });
    }

    const facetCheckboxes = document.querySelectorAll('.facet-checkbox__text');
    if (facetCheckboxes.length) {
      facetCheckboxes.forEach(el => {
        el.removeAttribute('aria-hidden');
      });
    }

    const multicolumnLinks = document.querySelectorAll('.multicolumn-card .link.animate-arrow');
    if (multicolumnLinks.length) {
      multicolumnLinks.forEach(link => {
        const card = link.closest('.multicolumn-card');
        const imgAlt = card?.querySelector('img')?.getAttribute('alt')?.trim();

        if (imgAlt) {
          link.setAttribute('aria-label', `Shop Now ${imgAlt}`);
        }
      });
    }

    const emptyLink = document.querySelectorAll('a[href]');
    if (emptyLink.length) {
      emptyLink.forEach(link => {
        const hasText = link.textContent.trim().length > 0;
        const hasMedia = link.querySelector('img, svg, picture, video');

        if (!hasText && !hasMedia) {
          link.remove();
        }
      });
    }
  };

  cleanA11y();

  if (document.body) {
    const observer = new MutationObserver(() => {
      cleanA11y();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});